import { Component, Schema } from "minecs";

@Component()
export class NoLocomotion extends Schema {}
